module.exports = __webpack_public_path__ + "img/wow-classic-logo.c52fc807.png";